import React, { Component } from 'react';
import TextField from '@mui/material/TextField';

type AuthFieldProps = {
    label: string,
    error: string,
    reference: string
}

type AuthErrorProps = {
    error: string,
    reference: string
}

const AuthError = (({ error, reference }: AuthErrorProps) => {
    if (error && error.length > 0) {
        return (<span className="text-danger" id={`${reference}-error`}>{error}</span>);
    }
    return (<span></span>);
});

const fieldType = (reference: string) => {
    if (reference === 'password' || reference === 'confirm-password') return 'password';
    return 'text';
}

const AuthField = React.forwardRef(({ label, error, reference }: AuthFieldProps, ref: any) => {
    return (
        <>
            <TextField
                label={label}
                id={reference}
                name={reference}
                inputRef={ref}
                type={fieldType(reference)}
                fullWidth={true}
            />
            <AuthError error={error} reference={reference} />
        </>
    )
});

export default AuthField;